import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ThemeProvider } from "./theme/ThemeProvider";
import "./styles.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Elemento raiz do dashboard não encontrado.");
}

createRoot(root).render(<StrictMode><ThemeProvider><App /></ThemeProvider></StrictMode>);
